<template>
  <div class="ywzs_box">
    <div class="in_abtCnt">
      <!-- title start -->
      <div class="ywzs_title">
        <span>
          <img class="ywzs_img1" src="@/assets/images/yw_ico_1.png" />
          {{ lange == "ch" ? zscqfw.zTitle.ch : zscqfw.zTitle.en }}
          <img class="ywzs_img2" src="@/assets/images/yw_ico_1.png" />
        </span>
      </div>
      <!-- title end -->

      <!-- -->
      <!-- <div class="ywzs_zs">
        <div
          class="z_box"
          v-for="(item, index) in zscqfw.list"
          :key="index"
          :style="index == 4 ? 'border:0;' : ''"
          @click="clickShow"
        >
          <img class="z_CntImg" :src="item.img" v-if="index == 4" />
          <span
            class="z_img"
            :style="'background-image:url(' + item.img + ')'"
            v-if="index != 4"
          ></span>
          <span class="z_title" v-if="index != 4">{{
            lange == "ch" ? item.title.ch : item.title.en
          }}</span>
          <div class="z_btm" v-if="index != 4">
            <span>{{ lange == "ch" ? item.txt.ch : item.txt.en }}</span>
            <img class="z_btmImg" src="@/assets/images/ina_ico_7.png" />
          </div>
        </div>
      </div> -->
      <div class="wow rollIn animated ywzs_zs">
        <div class="xd_imgBox">
          <img
            class="xd_imgLs"
            v-for="(item, index) in xdimg"
            :src="item.src"
            :style="item.style"
            @click="clickShow(item)"
          />
          <img class="xd_bg" src="@/assets/images/ico_bg_1o.png" alt="" />
        </div>
      </div>
      <!-- <div class="btn_x">
        <span>{{ lange == "ch" ? yewujishao.btn.ch : yewujishao.btn.en }}</span>
        <img class="x_1" src="@/assets/images/x_1.png" alt="" />
        <img class="x_2" src="@/assets/images/x_3.png" alt="" />
      </div> -->
      <div class="btn_h">
        <i class="h_x_1"></i>
        <span class="h_x_2" @click="clickShow" >{{
          lange == "ch" ? "我要咨询" : "Welcome to consult"
        }}</span>
        <img class="h_x_3" src="@/assets/images/t_ico_1.png" alt="" />
      </div>
      <!--//  -->
    </div>
    <div style="width: 100%; margin-top: 30px; display: block">
      <img class="x_4" src="@/assets/images/x_4.png" />
    </div>
    <!-- 弹窗 start -->
    <div class="tcBox" v-if="showTc" @click.stop="clickHide">
      <div
        class="cha1"
        :style="
          'content: url(' + require('../../../assets/images/cha.svg') + ');'
        "
      ></div>
      <div class="tcCnt" @click.stop="">
        <div class="t_center">
        <div class="div_t1">
          <span class="con_title">{{layerShowTitle}}</span>
        </div>
        <div class="div_t1">
          <span class="con_msg">{{layerShowTxt}}</span>
        </div>

          <div class="div_t1">
            <div
              class="div_t2"
              :style="
                'background-image:url(' +
                require('../../../assets/images/t_c_5.png') +
                ')'
              "
            >
              <span>{{ lange == "ch" ? "姓名:" : "Name:" }}</span>
            </div>
            <input type="text" class="t_input" v-model="name" maxlength="16" />
          </div>
          <div class="div_t1">
            <div
              class="div_t2"
              :style="
                'background-image:url(' +
                require('../../../assets/images/t_c_4.png') +
                ')'
              "
            >
              <span>{{ lange == "ch" ? "电话:" : "Tel:" }}</span>
            </div>
            <input type="tel" class="t_input" v-model="tel" maxlength="11" />
          </div>
          <div class="div_t1">
            <div
              class="div_t2"
              :style="
                'background-image:url(' +
                require('../../../assets/images/t_c_2.png') +
                ')'
              "
            >
              <span>{{lange == "ch" ? "邮箱:" : "Email:" }}</span>
            </div>
            <input type="email" class="t_input" v-model="emil" maxlength="30" />
          </div>
          <div class="div_t1">
            <div
              class="div_t2"
              :style="
                'background-image:url(' +
                require('../../../assets/images/t_c_1.png') +
                ')'
              "
            >
              <span>{{lange == "ch" ? "描述:" : "Eescribe:" }}</span>
            </div>
            <textarea v-if='lange == "ch"'
              class="textareas"
              placeholder='请描述您要咨询内容或业务方向'
              v-model="textareaTxt"
              maxlength="500"
            ></textarea>
            <textarea v-if='lange != "ch"'
              class="textareas"
              placeholder='Please describe the content or business direction you want to consult'
              v-model="textareaTxt"
              maxlength="500"
            ></textarea>
          </div>
          <div class="btn_div">
            <span class="btn" @click="clickBtn">{{lange == "ch" ? "提交咨询" : "Submit" }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗 end -->
  </div>
</template>

<script>
//知识产权专项服务
import { zixForm } from "@/api/index";
import { emailYz, checkPhone } from "@/utils/utils";
export default {
  name: "SpecialIntellectual",
  components: {},
  computed: {},
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
      zscqfw: {
        zTitle: {
          ch: "知识产权专项服务",
          en: "Special intellectual property services",
        },
        placeholder:"123123",//lange == "ch" ? "请描述您要咨询内容或业务方向" : "Please describe the content or business direction you want to consult",
        list: [
          {
            title: {
              ch: "科创板公司知识产权专项服务",
              en: "Special intellectual property services of Kechuang board company",
            },
            img: require("../../../assets/images/ina_ico_6_1.png"),
            txt: {
              ch: "我要咨询",
              en: "I want to consult",
            },
          },
          {
            title: {
              ch: "投资中知识产权尽职调查与评估",
              en: "Due diligence and evaluation of intellectual property in investment",
            },
            img: require("../../../assets/images/ina_ico_6_2.png"),
            txt: {
              ch: "我要咨询",
              en: "I want to consult",
            },
          },
          {
            title: {
              ch: "知识产权布局与保护",
              en: "Layout and protection of intellectual property rights",
            },
            img: require("../../../assets/images/ina_ico_6_3.png"),
            txt: {
              ch: "我要咨询",
              en: "I want to consult",
            },
          },
          {
            title: {
              ch: "知识产权维权",
              en: "Intellectual property rights protection",
            },
            img: require("../../../assets/images/ina_ico_6_4.png"),
            txt: {
              ch: "我要咨询",
              en: "I want to consult",
            },
          },
          {
            title: {
              ch: "科创板公司知识产权专项服务",
              en: "Special intellectual property services of Kechuang board company",
            },
            img: require("../../../assets/images/ina_ico_8.png"),
            txt: {
              ch: "我要咨询",
              en: "I want to consult",
            },
          },
          {
            title: {
              ch: "知识产权融资与变现",
              en: "Intellectual property financing and Realization",
            },
            img: require("../../../assets/images/ina_ico_6_5.png"),
            txt: {
              ch: "我要咨询",
              en: "I want to consult",
            },
          },
          {
            title: {
              ch: "商标注册/专利申请/著作权登记",
              en: "Trademark registration / patent application / copyright registration",
            },
            img: require("../../../assets/images/ina_ico_6_6.png"),
            txt: {
              ch: "我要咨询",
              en: "I want to consult",
            },
          },
          {
            title: {
              ch: "知识产权贯标辅导",
              en: "Guidance on implementation of intellectual property standards",
            },
            img: require("../../../assets/images/ina_ico_6_7.png"),
            txt: {
              ch: "我要咨询",
              en: "I want to consult",
            },
          },
          {
            title: {
              ch: "其他知识产权专项服务",
              en: "Other intellectual property special services",
            },
            img: require("../../../assets/images/ina_ico_6_8.png"),
            txt: {
              ch: "我要咨询",
              en: "I want to consult",
            },
          },
        ],
      },
      showTc: false,
      name: "",
      tel: "",
      emil: "",
      textareaTxt: "",
      xdimg: [],
      layerShowTxt:"",
      layerShowTitle:"",
      showListObj:{},
    };
  },
  created() {
    this.xdimgFunc();
    this.showListObj = this.$store.state.indexText;
  },
  methods: {
    xdimgFunc() {
      //多变型
      this.xdimg = this.lange == "ch" ? [
                                               {
                                                 src: require("../../../assets/images/xd_1.png"),
                                                 style: "width:30%;top: 6%;left: 17%;",
                                                 i:0,
                                               },
                                               {
                                                 src: require("../../../assets/images/xd_2.png"),
                                                 style: "width:28%;top: 4%;left: 48%;",
                                                 i:1,
                                               },
                                               {
                                                 src: require("../../../assets/images/xd_3.png"),
                                                 style: "width:22%;top: 17%;left: 70%;",
                                                 i:2,
                                               },
                                               {
                                                 src: require("../../../assets/images/xd_4.png"),
                                                 style: "width:16%;top: 47%;left: 80%;",
                                                 i:4,
                                               },
                                               {
                                                 src: require("../../../assets/images/xd_5.png"),
                                                 style: "width:27%;top: 71%;left: 55%;",
                                                 i:7,
                                               },
                                               {
                                                 src: require("../../../assets/images/xd_6.png"),
                                                 style: "width:25%;top: 78%;left: 28%;",
                                                 i:6,
                                               },
                                               {
                                                 src: require("../../../assets/images/xd_7.png"),
                                                 style: "width:25%;top:53%;left: 5%;",
                                                 i:5,
                                               },
                                               {
                                                 src: require("../../../assets/images/xd_8.png"),
                                                 style: "width:17%;top: 27%;left: 5%;",
                                                 i:3,
                                               },
                                             ] : [
                                                       {
                                                         src: require("../../../assets/images/xd_1_e.png"),
                                                         style: "width:30%;top: 6%;left: 17%;",
                                                         i:0,
                                                       },
                                                       {
                                                         src: require("../../../assets/images/xd_2_e.png"),
                                                         style: "width:28%;top: 4%;left: 48%;",
                                                         i:1,
                                                       },
                                                       {
                                                         src: require("../../../assets/images/xd_3_e.png"),
                                                         style: "width:22%;top: 17%;left: 70%;",
                                                         i:2,
                                                       },
                                                       {
                                                         src: require("../../../assets/images/xd_4_e.png"),
                                                         style: "width:16%;top: 47%;left: 80%;",
                                                         i:4,
                                                       },
                                                       {
                                                         src: require("../../../assets/images/xd_5_e.png"),
                                                         style: "width:27%;top: 71%;left: 55%;",
                                                         i:7,
                                                       },
                                                       {
                                                         src: require("../../../assets/images/xd_6_e.png"),
                                                         style: "width:25%;top: 78%;left: 28%;",
                                                         i:6,
                                                       },
                                                       {
                                                         src: require("../../../assets/images/xd_7_e.png"),
                                                         style: "width:25%;top:53%;left: 5%;",
                                                         i:5,
                                                       },
                                                       {
                                                         src: require("../../../assets/images/xd_8_e.png"),
                                                         style: "width:17%;top: 27%;left: 5%;",
                                                         i:3,
                                                       },
                                                     ];
    },
    clickShow(obj) {
      if (this.showTc) {
        this.showTc = false;
        this.layerShowTxt ="";
        this.layerShowTitle="";
      } else {
        this.showTc = true;
        if(obj.i == null){
          this.layerShowTxt ="";
          this.layerShowTitle="";
        }else{
          this.layerShowTxt = this.showListObj.inTitle3.list[obj.i].layerShow_ch;
          this.layerShowTitle = this.showListObj.inTitle3.list[obj.i].ch;
        }
      }
    },
    clickBtn() {
      if (this.yanzheng(this.name, "名字")) {
        return false;
      }
      if (this.yanzheng(this.tel, "电话")) {
        return false;
      }
      if (this.yanzheng(this.emil, "邮箱")) {
        return false;
      }
      if (this.yanzheng(this.textareaTxt, "描述")) {
        return false;
      }
      this.formApi();
      this.showTc = false;
    },
    clickHide() {
      this.showTc = false;
    },
    formApi() {
      //咨询表单提交
      var data = {
        name: this.name,
        phoneNum: this.tel,
        email: this.emil,
        market: this.textareaTxt,
      };
      zixForm(data)
        .then((response) => {
          if (response.code == 0) {
            this.name = "";
            this.tel = "";
            this.emil = "";
            this.textareaTxt = "";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    yanzheng(a, b) {
      if (a == "") {
        this.$message({
          showClose: true,
          message: b + "不能为空",
        });
        return true;
      }
      if (b == "邮箱") {
        if (!emailYz(a)) {
          this.$message({
            showClose: true,
            message: b + "格式不正确",
          });
          return true;
        }
      }
      if (b == "电话") {
        /*if (!checkPhone(a)) {
          this.$message({
            showClose: true,
            message: b + "格式不正确",
          });
          return true;
        }*/
      }
    },
  },
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ywzs_box {
  width: 100%;
  display: block;
  background-color: #eeeeee;
}
.in_abtCnt {
  width: 67.7%;
  min-height: 35px;
  display: block;
  margin: 0 auto;
  position: relative;
}
.ywzs_title {
  width: 100%;
  display: block;
  text-align: center;
  font-size: 40px;
  color: #0f3a58;
  padding: 70px 0 45px 0;
  font-family: shsm, shsb, "Avenir", Helvetica, Arial, sans-serif;
}
.ywzs_title > span {
  display: inline-block;
  position: relative;
  padding: 0 30%;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.ywzs_img1,
.ywzs_img2 {
  max-width: 30%;
  height: 2px;
  display: block;
  position: absolute;
  top: 50%;
}
.ywzs_img1 {
  left: 0;
}
.ywzs_img2 {
  right: 0;
}
.ywzs_js {
  width: 100%;
  display: block;
  font-size: 18px;
  color: #000;
  text-align: center;
  margin: 0 0 70px 0;
}

.ywzs_zs {
  width: 75%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 15%;
}
/*ls*/
.z_box {
  width: 30%;
  display: block;
  position: relative;
  border: 1px solid #e6ddce;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 122px;
  cursor: pointer;
  box-sizing: border-box;
}
.z_img {
  width: 60px;
  height: 60px;
  display: block;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -30px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 70% auto;
}
.z_title {
  width: 90%;
  display: block;
  margin: 38% 0 25% 5%;
  text-align: center;
  font-size: 18px;
  color: #333;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  font-weight: bold;
}
.z_btm {
  width: 100%;
  height: 50px;
  display: block;
  border-top: 1px solid #e6ddce;
  background-color: #cab897;
  position: absolute;
  left: 0;
  bottom: 0;
}
.z_btm > span {
  display: block;
  padding-left: 40%;
  font-size: 16px;
  color: #fff;
  line-height: 50px;
}
.z_btmImg {
  width: 27px;
  height: 27px;
  display: block;
  position: absolute;
  top: 50%;
  right: 10%;
  margin-top: -13px;
}
.z_CntImg {
  width: 70%;
  display: block;
  position: absolute;
  top: 30%;
  left: 15%;
}
/**/
.tcBox {
  width: 100%;
  height: 100%;
  display: block;
  position: fixed;
  top: 0%;
  /* left: 0%; */
  background-color: rgba(24, 30, 44, 0.9);
  z-index: 20;
}
.tcCnt {
  width: 60%;
  display: block;
  margin: 8% 20%;
  border-radius: 6px;
}
.t_center {
  width: 100%;
  display: block;
}
.textareas {
  width: 84%;
  height: 120px;
  display: block;
  resize: none;
  border: 0;
  outline: medium;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 10px;
}
.btn_div {
  width: 100%;
  display: block;
  text-align: center;
}
.btn {
  display: inline-block;
  background-color: #c29e67;
  text-align: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  margin-top: 70px;
  padding: 6px 60px;
  border-radius: 6px;
}
.cha1 {
  width: 40px;
  height: 40px;
  display: block;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}
.div_t1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.div_t2 {
  width: 90px;
  height: 40px;
  display: block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 25px 25px;
}
.div_t2 > span {
  font-size: 14px;
  color: #cac9c5;
  line-height: 40px;
  padding-left: 40px;
}

.t_input {
  width: 80%;
  height: 40px;
  display: block;
  background-color: rgba(255, 255, 255, 0.7);
  border: 0;
  padding: 0;
  margin-bottom: 12px;
  outline: medium;
  padding: 0 2%;
}

/* 多变型 */
.xd_imgBox {
  width: 75%;
  display: block;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}
.xd_bg {
  width: 100%;
  display: block;
}
.xd_imgLs {
  display: block;
  position: absolute;
  cursor: pointer;
}
.x_4 {
  width: 100%;
  display: block;
}
.btn_x {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 30px 0 0 0;
}
.x_1 {
  width: 79%;
  height: 4px;
  display: block;
  margin-top: 1.5%;
}
.x_2 {
  width: 19%;
  display: block;
  cursor: pointer;
}

/* 横线按钮 */
.btn_h {
  width: 100%;
  height: 34px;
  display: block;
  position: relative;
  margin-top: 100px;
}
.h_x_1 {
  width: 70%;
  height: 2px;
  display: block;
  position: absolute;
  background-color: #c28e33;
  top: 18px;
  left: 0;
}
.h_x_2 {
  display: block;
  position: absolute;
  top: 2px;
  right: 7%;
  font-size: 22px;
  color: #c28e33;
}
.h_x_3 {
  width: 34px;
  height: 34px;
  display: block;
  position: absolute;
  top: 0;
  right: 0;
}

@media only screen and (max-width: 1440px) {
  .in_abtCnt {
    width: 90%;
  }
  .z_btm > span {
    width: 80%;
    padding-left: 3%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .z_btmImg {
    right: 2%;
  }
}
@media only screen and (max-width: 768px) {
  .tcCnt {
    width: 80%;
    margin: 20% 0 0 10%;
  }
  .z_box {
    width: 48%;
  }
  .x_1 {
    width: 70%;
    margin-top: 1.8%;
  }
  .x_2 {
    width: 26%;
  }
  .h_x_1 {
    width: 66%;
    height: 2px;
    display: block;
    position: absolute;
    background-color: #c28e33;
    top: 18px;
    left: 0;
  }
}
@media only screen and (max-width: 600px) {
  .z_box {
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 425px) {
  .ywzs_title {
    font-size: 18px;
    padding: 30px 0;
  }
  .z_title {
    font-size: 12px;
  }
  .z_btm {
    height: 30px;
  }
  .z_btm > span {
    font-size: 12px;
    line-height: 30px;
  }
  .z_img {
    width: 40px;
    height: 40px;
    display: block;
    position: absolute;
    top: 10%;
    left: 50%;
    margin-left: -20px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 70% auto;
  }
  .z_btmImg {
    width: 20px;
    height: 20px;
    margin-top: -10px;
  }
  .z_box:nth-child(5) {
    display: none;
  }
  .tcCnt {
    margin: 25% 0 0 10%;
  }
  .div_t2 {
    background-size: 20px 20px;
  }
  .div_t2 > span {
    font-size: 12px;
    color: #cac9c5;
    line-height: 40px;
    padding-left: 25px;
  }
  .x_1 {
    width: 60%;
    margin-top: 2%;
  }
  .x_2 {
    width: 36%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BusinessIntroduction/component/SpecialIntellectualXin.vue